import React from "react";

import Image from "next/image";
import Link from "next/link";
import SSLImage from "public/images/ssl-certificate.png";

import {
  footerDataBrideByProfession,
  footerTopLinks,
  FooterTopLinks,
  goldenMeetsFooterTopLinks,
} from "@/constants/footerTopLinks";
import { ConditionalRender } from "@/lib/conditional-render/ConditionalRender";
import { projectIs } from "@/lib/feature-flags/featureFlagsDeside.helpers";
import { useDynamicFeatureFlags } from "@/services/dynamic-feature-flags/components/DynamicFeatureFlagsProvider";
import { clsxm } from "@/utils/tailwindMerge";

import { SocialMediaIcons } from "./components/SocialMediaIcons";
import { useFooterData } from "./hooks/useFooterData";

export const Footer: React.FC = () => {
  const findBridesByCountryData = useFooterData();
  const { isBlockRUByCountry } = useDynamicFeatureFlags();

  const footerTopLinksProcessed = footerTopLinks.map((column) => {
    return {
      ...column,
      items: isBlockRUByCountry
        ? column.items.filter(({ hideOnRuBlockedFlag }) => !hideOnRuBlockedFlag)
        : column.items,
    };
  });

  return (
    <footer>
      <div className="py-8 px-4 md:px-0 flex flex-col gap-8">
        <FooterTopLinksSection
          footerTopLinks={
            projectIs(["GM"])
              ? goldenMeetsFooterTopLinks
              : footerTopLinksProcessed
          }
        />
        <ConditionalRender on={!projectIs(["GM"])}>
          <FooterBridesByCountrySection footerData={findBridesByCountryData} />
        </ConditionalRender>
        <BridesByProfession />
      </div>
      <section className="pb-4 pr-4 flex flex-col items-center md:flex-row md:justify-between">
        <div className="flex flex-col items-center md:items-start">
          {/* <address className="text-grey1-700 text-sm md:text-start text-center">
            Global clarity holdings llp, The Hatchery Ni, Unit 19, Antrim
            Enterprise Park, Antrim, Northern Ireland, BT41 1JZ,
          </address>
          <p className="text-grey1-700 text-sm md:text-start text-center">
            © Golden Bride, 2013-2024. All rights reserved.
          </p> */}
          <Image
            // FIXME: return to makeUrl when this svg is on tgb cloudfront
            src={
              "https://ddev6uq7v65vs.cloudfront.net/imgs/copyright.svg?v=2025"
            }
            unoptimized
            // src={makeUrl(CLOUDFRONT_FONTS_LINK, "imgs/copyright.svg")}
            alt="Golden Bride logo"
            width={325}
            height={36}
            loading="eager"
            priority
          />
        </div>
        <Link
          target="_blank"
          href="https://www.sslshopper.com/ssl-checker.html#hostname=goldenbride.net"
        >
          <Image className="mt-4" src={SSLImage} alt="SSL certificate"></Image>
        </Link>
      </section>
    </footer>
  );
};

type FooterTopLinsSectionProps = {
  footerTopLinks: FooterTopLinks;
};

const FooterTopLinksSection: React.FC<FooterTopLinsSectionProps> = ({
  footerTopLinks,
}) => {
  return (
    <div className={clsxm("grid gap-4 grid-cols-2", "md:gap-1 md:grid-cols-4")}>
      {footerTopLinks.map((column, i) => {
        return (
          <section key={i}>
            <span className="uppercase text-base font-bold text-grey1-200">
              {column.header}
            </span>
            <ul>
              {column.items.map((linkItem, i) => {
                return (
                  <li key={i}>
                    {/* // TODO: WEB-1726 changa to Link */}
                    <a href={linkItem.path} className="text-sm text-pink">
                      {linkItem.content}
                    </a>
                  </li>
                );
              })}
              <li key={i}>
                <ConditionalRender on={column.header === "Partners"}>
                  <SocialMediaIcons />
                </ConditionalRender>
              </li>
            </ul>
          </section>
        );
      })}
    </div>
  );
};

type BritesByCountryProps = {
  footerData: ReturnType<typeof useFooterData>;
};

const FooterBridesByCountrySection: React.FC<BritesByCountryProps> = ({
  footerData,
}) => {
  return (
    <section>
      <span className="uppercase text-base font-bold text-grey1-200">
        FIND BRIDE BY COUNTRY
      </span>
      <div
        className={clsxm("grid gap-4 grid-cols-2", "md:gap-1 md:grid-cols-4")}
      >
        {footerData.map((column, i) => {
          return (
            <ul key={i}>
              {column.map((liItem, i) => {
                return (
                  <li key={i}>
                    {/* // TODO: WEB-1726 changa to Link */}
                    <a href={"/" + liItem.url} className="text-sm text-pink">
                      {liItem.title}
                    </a>
                  </li>
                );
              })}
            </ul>
          );
        })}
      </div>
    </section>
  );
};

const BridesByProfession = () => {
  return (
    <section>
      <span className="uppercase text-base font-bold text-grey1-200">
        FIND BRIDE BY PROFESSION
      </span>
      <div
        className={clsxm("grid gap-4 grid-cols-2", "md:gap-1 md:grid-cols-4")}
      >
        {footerDataBrideByProfession.items.map((column, i) => {
          return (
            <ul key={i}>
              {column.map((liItem, i) => {
                return (
                  <li key={i}>
                    {/* // TODO: WEB-1726 change to Link */}
                    <a href={"/" + liItem.path} className="text-sm text-pink">
                      {liItem.content}
                    </a>
                  </li>
                );
              })}
            </ul>
          );
        })}
      </div>
    </section>
  );
};
